import React, { useEffect, useState } from "react";

import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "./AuthContext";
import { CookieKey, getCookie } from "../../hooks/useCookie";

interface Props {
  children: JSX.Element;
}

function PrivateRoute({ children }: Props) {
  const { authenticated, login } = useAuth();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthentication = async () => {
      const token = getCookie(CookieKey.JWT_TOKEN);

      if (token && !authenticated) {
        login();
      }
      setIsLoading(false);
    };

    checkAuthentication();
  }, [location.pathname]);

  if (isLoading) {
    return <div>Loading...</div>; // Or your preferred loading indicator
  }

  if (!authenticated && !["/login", "/register"].includes(location.pathname)) {
    return <Navigate to="/login" />;
  }

  if (authenticated && ["/login", "/register"].includes(location.pathname)) {
    return <Navigate to="/episodes" />;
  }

  return children;
}

export default PrivateRoute;
